module.exports = __webpack_public_path__ + "static/media/1a.bd0c9bed.jpg";